export const Lock = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Hengelås</title>
      <g clipPath="url(#clip0_7236_77)">
        <path
          d="M12.6667 6.66675H3.33333C2.59695 6.66675 2 7.2637 2 8.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V8.00008C14 7.2637 13.403 6.66675 12.6667 6.66675Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 3.33341C10.6667 1.86075 9.47271 0.666748 8.00004 0.666748C6.52737 0.666748 5.33337 1.86075 5.33337 3.33341V6.66675"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7236_77">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
